import React from 'react';
import styles from '../Operations.module.css';

interface MGOSComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGOS - Overstock
 * KPI information component
 */
const MGOS: MGOSComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Overstock Inventory is one of 2 metrics that make up Productivity Level 0 Unproductive.<br/>
        Overstock Inventory is inventory in the stores system that has 2 or more years of supply.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        SKU-level detail can be found in the MEGA report, Overstock tab.<br/>
        Overstock is typically a product that is sold in your store, but you just happen to have an overabundance of it. <br/><br/>
        The goal here is to reduce the amount of inventory that is tied up in these SKUs through dynamic promotions, temporary sales, or strategic clutter.<br/><br/>
        The Overstock report selects items with at least two years of expected supply on hand.<br/>
        These items do not have recent purchase history (to exclude upcoming promotional or new items) or oversupply caused by a high order multiple.<br/><br/>
        Furthermore, Peer data is used to exclude SKUs which exhibit peaky demand.<br/>
        What we are left with then is a list of SKUs which have a high inventory value (QOH x Average Cost) and a low probability of selling down to a reasonable inventory level anytime soon.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        2.5% or less
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        <strong>For more information, see the Ace Way of Retailing documents titled</strong> <a href="https://acenet.aceservices.com/awor-old/inventory-management-old/overstock-inventory-setup" target="_blank" rel="noopener noreferrer" className={styles.link}>Overstock Inventory Setup</a>
      </div>
    </div>
  );
};

MGOS.title = 'Mango Overstock Inventory';
MGOS.kpiHyperlink = 'dynamicURL:ACENET:description';
MGOS.actionTitle = 'Start Closeout Management';
MGOS.actionHyperlink = '';
export default MGOS;

